var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DashboardKPIs',{attrs:{"currency":_vm.currency,"kpi-data":_vm.kpiDataComputed}})}
var staticRenderFns = []

export { render, staticRenderFns }